import cn from 'classnames'
import React, { ComponentProps, forwardRef, ReactElement } from 'react'

import style from './Box.style'

type BoxProps = {
  className?: string
  variant?: 'default' | 'highlight' | 'highlightContent'
  noPadding?: boolean
  padding?: string
  testId?: string
  'data-testid'?: string
  onClick?: () => void
} & Omit<ComponentProps<'div'>, 'onClick'>

const Box = forwardRef<HTMLDivElement, BoxProps>(
  function Box(props, forwardedRef): ReactElement {
    const {
      className = '',
      variant = 'default',
      noPadding,
      padding,
      testId,
      onClick,
      children,
      style: inlineStyle,
      ...rest
    } = props

    const combinedClassName = cn('Box', className, variant, {
      noPadding,
      customPadding: !!padding,
      clickable: !!onClick,
    })

    const combinedStyle = {
      ...inlineStyle,
      ...(padding ? { padding } : {}),
    }

    const handleClick = () => {
      if (onClick) {
        onClick()
      }
    }

    const handleKeyUpPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (onClick && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault()
        onClick()
      }
    }

    return (
      <div
        ref={forwardedRef}
        css={style}
        className={combinedClassName}
        data-testid={testId || props['data-testid']}
        onClick={onClick ? handleClick : undefined}
        onKeyUp={onClick ? handleKeyUpPress : undefined}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        style={combinedStyle}
        {...rest}
      >
        {children}
      </div>
    )
  },
)

export default Box
